import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 4v3h5.5v12h3V7H19V4z"
}), 'Title');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Title.js
// module id = 6834
// module chunks = 2